import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiMapPin, FiMail, FiBriefcase } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand & Info */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2 text-white">
              <div className="w-8 h-8 bg-teal-600 rounded flex items-center justify-center">
                <SafeIcon icon={FiBriefcase} className="text-white text-sm" />
              </div>
              <span className="font-bold text-xl tracking-tight">
                Nebenjob <span className="text-teal-500">Nord</span>
              </span>
            </Link>
            <p className="text-sm text-slate-400 mt-4 leading-relaxed">
              Die regionale Vermittlungsplattform für flexible Nebenjobs, Minijobs und Aushilfsjobs in Hamburg und Norddeutschland.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Plattform</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/bewerber" className="hover:text-teal-400 transition">Für Bewerber</Link></li>
              <li><Link to="/unternehmen" className="hover:text-teal-400 transition">Für Unternehmen</Link></li>
              <li><Link to="/jobbereiche" className="hover:text-teal-400 transition">Jobbereiche</Link></li>
              <li><Link to="/ueber-uns" className="hover:text-teal-400 transition">Über uns</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiMapPin} className="mt-1 flex-shrink-0 text-teal-500" />
                <span>
                  Nebenjob Nord<br />
                  Axel-Springer-Platz 3<br />
                  20355 Hamburg
                </span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="flex-shrink-0 text-teal-500" />
                <a href="mailto:info@nebenjob-nord.de" className="hover:text-teal-400 transition">
                  info@nebenjob-nord.de
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Rechtliches</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/impressum" className="hover:text-teal-400 transition">Impressum</Link></li>
              <li><Link to="/datenschutz" className="hover:text-teal-400 transition">Datenschutz</Link></li>
              <li><Link to="/agb" className="hover:text-teal-400 transition">Vermittlungsbedingungen</Link></li>
              <li><Link to="/kontakt" className="hover:text-teal-400 transition">Kontaktformular</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} Nebenjob Nord. Alle Rechte vorbehalten.</p>
          <p>Made with ❤️ in Hamburg</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;